import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

import { PostResponse } from './useGetPosts';

export type ApiResponse_Get_Post = PostResponse;

const METHOD = 'GET';
const ENDPOINT = 'posts/{postId}';

export const POST_QUERY_KEY = (postId: number) =>
  getQueryKey(
    METHOD,
    getResolvedEndpoint(ENDPOINT, { postId: postId.toString() }),
    {}
  );

export const useGetPost = (
  params: { postId: number },
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token && !!params.postId,
    queryKey: POST_QUERY_KEY(params.postId),
    queryFn: async () => {
      try {
        const endpoint = getResolvedEndpoint(ENDPOINT, {
          postId: params.postId.toString(),
        });

        const data = await handleApiCall<ApiResponse_Get_Post, Record<string, never>>(
          session,
          METHOD,
          endpoint,
          {}
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch post.', { variant: 'error' });
        throw err;
      }
    },
  });
};